// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bge_a","ReactCrop--disabled":"bge_b","ReactCrop--circular-crop":"bge_c"};